import _ from 'lodash'
import React, { createContext, useContext, useState, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import { Checkbox, Toolbar } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'

import { SCROLL_CONTAINER_PADDING } from 'src/legacy/components/ScrollContainer'

const SelectableItemsContext = createContext(null)

export const SelectableItems = ({ children }) => {
  const [selected, setSelected] = useState([])
  const value = { selected, setSelected }
  return <SelectableItemsContext.Provider value={value}>{children}</SelectableItemsContext.Provider>
}

SelectableItems.propTypes = {
  children: PropTypes.node.isRequired,
}

export const SelectableItemCheckbox = ({ value }) => {
  const { selected, setSelected } = useContext(SelectableItemsContext)
  const isChecked = _.includes(selected, value)
  const onChange = (event) => {
    if (event.target.checked) {
      setSelected([...selected, value])
    } else {
      setSelected(_.without(selected, value))
    }
  }
  return <Checkbox checked={isChecked} color="primary" onChange={onChange} />
}

SelectableItemCheckbox.propTypes = {
  value: PropTypes.string.isRequired,
}

const useStyles = makeStyles((theme) => ({
  // Sticky rather than fixed so the bar spans its container instead of the viewport, and so it
  // settles into flow at the end of the scroll rather than covering whatever renders last. Sticky
  // is measured against the nearest scrolling ancestor, so the container must not clip its overflow
  // (MUI's Card does by default). The app bar level keeps it above the rows it floats over but
  // under Dialogs and their backdrop.
  root: {
    position: 'sticky',
    // Cancels the scroll container's padding so the bar sits flush with the bottom of the window
    // while it floats. At rest the offset no longer applies, leaving that padding as a gap below.
    bottom: -SCROLL_CONTAINER_PADDING,
    zIndex: theme.zIndex.appBar,
    borderBottomLeftRadius: theme.shape.borderRadius,
    borderBottomRightRadius: theme.shape.borderRadius,
    background: theme.palette.primary.main,
    boxShadow: theme.shadows[8],
  },
}))

export const SelectableItemsToolbar = ({ children, filter }) => {
  const classes = useStyles()
  const { selected, setSelected } = useContext(SelectableItemsContext)
  const clearSelection = useCallback(() => setSelected([]), [setSelected])
  useEffect(() => clearSelection(), [clearSelection, filter])
  if (selected.length === 0) {
    return null
  }

  return (
    <Toolbar classes={classes} variant="dense">
      {children({ clearSelection, selected })}
    </Toolbar>
  )
}

SelectableItemsToolbar.propTypes = {
  children: PropTypes.func.isRequired,
  filter: PropTypes.shape({}),
}
